// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class CustodialPlan {
    constructor(id) {
        this._dataByInstruments = {}; //= new ConcurrentDictionary<string, CustodialData>();
        this._dataByInstrumentGroup = {}; //= new ConcurrentDictionary<int, CustodialData>();
        this._dataByInstrumentsHasValue = false;
        this._dataByInstrumentGroupHasValue = false;
        this.Id = id;
    }
    GetData(instr) {
        if (isNullOrUndefined(instr)) {
            return null;
        }
        let data = this._dataByInstruments[instr.Id]; // InstrumentId === Id
        if (!isNullOrUndefined(data)) {
            return data;
        }
        data = this._dataByInstrumentGroup[instr.TypeId]; // InstrumentGroupId === TypeId
        if (!isNullOrUndefined(data)) {
            return data;
        }
        return this._defaultData;
    }
    Update(message) {
        this.Name = message.Name;
        this._dataByInstruments = {};
        this._dataByInstrumentGroup = {};
        this._defaultData = null;
        this._dataByInstrumentsHasValue = false;
        this._dataByInstrumentGroupHasValue = false;
        for (let i = 0; i < message.Data.length; i++) {
            this.AddData(message.Data[i]);
        }
    }
    AddData(data) {
        if (data.InstrumentId) {
            this._dataByInstruments[data.InstrumentId] = data;
            this._dataByInstrumentsHasValue = true;
        }
        else if (data.InstrumentGroupId !== null) {
            this._dataByInstrumentGroup[data.InstrumentGroupId] = data;
            this._dataByInstrumentGroupHasValue = true;
        }
        else {
            this._defaultData = data;
        }
    }
    IsZero() {
        return (!this._dataByInstrumentsHasValue &&
            !this._dataByInstrumentGroupHasValue &&
            this._defaultData.Fee === 0 &&
            this._defaultData.InstrumentGroupId === null &&
            this._defaultData.InstrumentId === '');
    }
}
